import { settings } from "app";

// Styled row for a SimpleList primary/secondary/tertiary text — renders one or more
// "Label: value" pairs on a single line. Pass a single-item `fields` array for a plain
// "Label: value" row, or multiple items to combine several pairs on one line (e.g. "Начало: X Край: Y").
// Omit `label` (or pass a falsy one) to render the bare value with no "Label: " prefix —
// use this when the Datagrid column it mirrors has no `label` either; never invent one.
export const MobileListRow = ({ fields, style }) => (
  <p style={style}>
    {fields.map(({ label, value }, index) => (
      <span key={label || index}>
        {label ? <strong style={settings.style.mobileLabel}>{label}: </strong> : null}
        {value}
        {index < fields.length - 1 ? " " : null}
      </span>
    ))}
  </p>
);
